export const formPermissions = {
    CREATE: {
        key: 'Forms.Create',
        name: 'Create Forms',
        description: 'Create and update custom forms'
    },
    EDIT_RESPONSE:{
        key: 'Forms.EditResponse',
        name: 'Edit Form Response',
        description: 'Edit custom forms responses'
    }
}